import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { baseColors } from "theme";

// MAX-3878 — Delete Category flows (empty + Move-&-Delete).
export const styles = (theme: Theme) => ({
	actions: {
		padding: "16px 24px",
	},
	body: {
		marginBottom: 16,
	},
	// Destructive confirm button (Delete Category / Move & Delete Category) — red per Figma.
	destructive: {
		backgroundColor: baseColors.brightRed,
		color: baseColors.white,
		"&:hover": {
			backgroundColor: baseColors.brightRed,
		},
	},
} satisfies Record<string, CSSObject>);
